"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.productRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    getProductsAvailabilities: {
        callMethod: 'GET',
        endpoint: '/products/availability',
    },
    getProductsByPharmaCode: {
        callMethod: 'GET',
        endpoint: '/products/pharmacode/search',
    },
    getProductsByGtin: {
        callMethod: 'GET',
        endpoint: '/products/gtin/search',
    },
    calculateGenericSavingPotential: {
        callMethod: 'GET',
        endpoint: '/generic-potential/calculate',
    },
    getOrderablePharmaCodes: {
        callMethod: 'GET',
        endpoint: '/products/orderable/pharma-codes',
    },
    searchProducts: {
        callMethod: 'GET',
        endpoint: '/products/search-with-filters',
    },
});
//# sourceMappingURL=product.methods.js.map